import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { NOTIFICATION_TYPE } from '../../../../constants/common'
import { BUTTON_HEIGHT_40 } from '../../../Button'
import {
  FormInlineNotifications,
  useFormValidationErrorsNotification,
} from '../../../Form'
import { PROFILE_CONTACTS_WIDGET_QA_NAME } from '../ProfileContactsWidget.constants'
import { getContactQaName } from '../ProfileContactsWidget.utils'
import { ProfileContactsWidgetFormButtons } from '../ProfileContactsWidgetFormButtons'
import { ProfileContactsWidgetLabel } from '../ProfileContactsWidgetLabel'
import {
  getErrorBorderStyle,
  PROFILE_CONTACTS_WIDGET_DELETE_NOTIFICATION_ID,
  PROFILE_CONTACTS_WIDGET_NOTIFICATION_KEY,
} from '../ProfileContactsWidgetListCell'
import { ProfileContactsWidgetListCellButton } from '../ProfileContactsWidgetListCellButton'
import { ProfileContactsWidgetListCellEditInput } from '../ProfileContactsWidgetListCellEditInput'

import * as styles from './ProfileContactsWidgetListCellEditFields.module.css'

function ProfileContactsWidgetListCellEditFields({
  canDelete,
  infoTooltipKey,
  isDeleteValue,
  label,
  name,
  notifications,
  qaId,
  typeConfig,
  onClick,
  onDelete,
  onDirtyChange,
  onRemoveNotification,
  onSetNotification,
}) {
  const { t } = useTranslation()

  const { dirty, isSubmitting } = useFormikContext()

  useFormValidationErrorsNotification({
    onRemoveNotification,
    onSetNotification,
  })

  useEffect(() => {
    onDirtyChange?.(dirty)
  }, [dirty])

  useEffect(() => {
    if (isDeleteValue) {
      onSetNotification({
        id: PROFILE_CONTACTS_WIDGET_DELETE_NOTIFICATION_ID,
        text: t(
          canDelete
            ? PROFILE_CONTACTS_WIDGET_NOTIFICATION_KEY.deleteValue
            : PROFILE_CONTACTS_WIDGET_NOTIFICATION_KEY.cannotDeleteValue
        ),
        type: NOTIFICATION_TYPE.error,
      })
    } else {
      onRemoveNotification(PROFILE_CONTACTS_WIDGET_DELETE_NOTIFICATION_ID)
    }
  }, [isDeleteValue])

  return (
    <div className={styles.wrapper}>
      <div className={styles.input}>
        <FormInlineNotifications
          className={styles.notifications}
          notifications={notifications}
        />

        <ProfileContactsWidgetLabel
          isSecondary
          className={styles.label}
          infoTooltipKey={infoTooltipKey}
          label={label}
        />
        <div className={styles.inputRow}>
          <ProfileContactsWidgetListCellEditInput
            autoFocus
            name={name}
            typeConfig={typeConfig}
          />
          {canDelete ? (
            <ProfileContactsWidgetListCellButton
              disabled={isSubmitting}
              height={BUTTON_HEIGHT_40}
              qaName={getContactQaName({
                id: qaId,
                qaName: PROFILE_CONTACTS_WIDGET_QA_NAME.deleteButton,
              })}
              style={getErrorBorderStyle(isDeleteValue)}
              tooltip={t('ProfileContactsWidget.DeleteBtnKey')}
              onClick={onDelete}
            />
          ) : null}
        </div>
      </div>
      <ProfileContactsWidgetFormButtons onCancel={onClick} />
    </div>
  )
}

export default ProfileContactsWidgetListCellEditFields
